


















































































































































































import ICustomerAdresses from '@/store/models/ICustomerAdresses';
import IListCountries from '@/store/models/IListCountries';
import IListAdressTypes from '@/store/models/IListAdressTypes';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class CustomerAdressesSelector extends Vue {
    searchCustomerAdresses: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    headers: any = [
        { text: 'Street',
            align: 'start',
            value: 'street'
        },
        { text: 'Number', value: 'number' },
        { text: 'City', value: 'city' },
        { text: 'ZipCode', value: 'zipCode' },
        { text: 'Country', value: 'countryName' },
        { text: 'Code', value: 'code' },
        { text: 'TypeName', value: 'typeName' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : ICustomerAdresses = {
        id: "",
        street: "",
        number: "",
        city: "",
        zipCode: "",
        idListCountry: "",
        countryName: "",
        code: "",
        idCustomer: "",
        idListAdressType: "",
        typeName: ""
    }
    defaultItem : ICustomerAdresses = {
        id: "",
        street: "",
        number: "",
        city: "",
        zipCode: "",
        idListCountry: "",
        countryName: "",
        code: "",
        idCustomer: "",
        idListAdressType: "",
        typeName: ""
    }
    sortBy: string = 'street';
    sortDesc: boolean = false;

    @Prop({ type: Array, required: true })
    CustomerAdressesList !: ICustomerAdresses[];
    @Prop({ type: Array, required: true })
    ListCountries !: IListCountries[];
    @Prop({ type: Array, required: true })
    ListAdressTypes !: IListAdressTypes[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    
    selectedCustomerAdres : ICustomerAdresses[] = [];
    selectedCountry: any = null;
    selectedAdressType: any = null;

    get formTitle() { return this.editedIndex === -1 ? 'New Adress' : 'Edit Adress'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    editCustomerAdresses (item: any, dbox = true) {
        if (this.selectedCustomerAdres.length > 0) {
            this.editedIndex = this.CustomerAdressesList.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.selectedCountry = this.ListCountries.find(p => p.id === this.editedItem.idListCountry);
            this.selectedAdressType = this.ListAdressTypes.find(p => p.id === this.editedItem.idListAdressType);
            this.dialog = true;
        }
    }

    saveCustomerAdresses () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.setCountry();
            this.setTypeName();
            if (this.editedIndex > -1) {
                this.$emit('editCustomerAdress', this.editedItem);
                Object.assign(this.CustomerAdressesList[this.editedIndex], this.editedItem);
            } else {
                this.$emit('saveCustomerAdress', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageInfo', 'All required fields must be filled out');
        }
    }

    deleteCustomerAdresses (customerAdres: ICustomerAdresses) {
        if (this.selectedCustomerAdres.length > 0) {
            this.$emit('deleteCustomerAdress', customerAdres);
            this.close();
        }
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    setCountry() {
        if (this.selectedCountry) {
            let country: IListCountries = this.ListCountries.find(p => p.countryName === this.selectedCountry.countryName)!;
            if (country) {
                this.editedItem.idListCountry = country.id;
                this.editedItem.countryName = country.countryName;
                this.editedItem.code = country.code;
            }
        }
    }

    setTypeName() {
        if (this.selectedAdressType) {
            let adresType: IListAdressTypes = this.ListAdressTypes.find(p => p.typeName === this.selectedAdressType.typeName)!;
            if (adresType) {
                this.editedItem.idListAdressType = adresType.id;
                this.editedItem.typeName = adresType.typeName;
            }
        }
    }

    select(item : ICustomerAdresses) : void {
        let index : number = this.selectedCustomerAdres.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedCustomerAdres = [item];
        } else {
            let customerAdres = this.selectedCustomerAdres.find(w => w.id === item.id);
            if (!customerAdres) {
                this.selectedCustomerAdres = [];
            }
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
